import React from 'react';
import { connect } from 'react-redux';
import './MembershipOverview.scss';
import { getMyMemberships, selectedMember } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { setUserId } from '../../../../../Redux/Actions/EndUser/MembershipAction';
import { auth } from '../../../../../services';
import { provideIntlService } from '@progress/kendo-react-intl';
import { Link, Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { history } from '../../../../../helpers/history';

class MembershipOverview extends React.Component {
    componentDidMount() {
        var userId = auth.getAuthUserId();
        this.props.getMyMemberships(userId);
    }

    setMembershipUserId = () => {
        this.props.setUserId(auth.getAuthUserId());
    }

    render() {
        const organizationsDisplay = this.props.myMemberships.constructor.name === 'Array' ? this.props.myMemberships.map((item, i) => {
            return (
                <li className="list-group-item myMembershipList" key={i}>
                    <label className="myMemebershipLabel listLabels" >Membership Number: <p className="myMembershipLinkText listLabels" onClick={() => {
                        this.props.selectedMember(item);
                        history.push('/my-membership');
                    }}>{item.membershipNumber}</p></label>
                    <label className="myMemebershipLabel listLabels" >Organization Name: <label className="myMembershipListText listLabels">{item.organizationName}</label></label>
                    <label className="myMemebershipLabel listLabels">Renew Date: <label className="myMembershipListText listLabels">{provideIntlService(this).formatDate((new Date(item.nextRenewDate)), 'MM/d/y')}</label> </label>
                    <label className="myMemebershipLabel listLabels" >Assigned To:
                        {item.fullName ? <label className="myMembershipListText listLabels">{item.fullName}</label>
                            : <label className="myMembershipListText unassigned listLabels">Unassigned</label>
                        }
                    </label>
                </li>
            );
        }) : "";

        return (


            <div className="my-organization background-white" >
                <h3 className="main-title">My Memberships</h3>
                {/* <button onClick={this.setMembershipUserId} className="btnLink btn btn-sm btnPrimary">Add Membership</button> */}
                <p>Click Membership Number to view Membership details</p>
                {this.props.loading ? <div className="card m-2 " style={{ verticalAlign: "middle", alignItems: 'center' }}>
                    <CircularProgress style={{ display: 'block', margin: 'auto' }} /> <label>Loading...</label>
                </div> :
                    <div className="card mb-2">
                        <ul className="list-group list-group-flush dashboard-info-list">{organizationsDisplay}</ul>
                    </div>
                }
            </div >

        );
    }
}

function mapStateToProps(state) {
    return {
        myMemberships: state.accountDetails.myMemberships,
        loading: state.accountDetails.getting,

    };
}

export default connect(mapStateToProps, { getMyMemberships, setUserId, selectedMember })(MembershipOverview);
